import WeekDays from "app/pages/PrePackage/components/DatePickerCalendar/WeekDays";
import { Skeleton } from "app/components/ui/Skeleton/Skeleton";
import { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { TABLET_GRID_STYLE } from "app/pages/.shared/CalendarList/CalendarList";
import "./CalendarListSkeleton.scss";

const SKELETON_MONTHS = 3;
const SKELETON_ROWS_PER_MONTH = 5;
const SKELETON_TILES_PER_MONTH = SKELETON_ROWS_PER_MONTH * 7;

const CalendarListSkeleton = () => (
	<div
		className="date-picker-calendar date-picker-calendar--tablet"
		style={TABLET_GRID_STYLE}
		aria-busy="true"
		aria-live="polite"
	>
		<WeekDays variant={TYPOGRAPHY_VARIANTS.SMALL} />
		{Array.from({ length: SKELETON_MONTHS }).map((_unused, monthIndex) => (
			<div className="datepicker-calendar-list-item" key={monthIndex}>
				<div className="datepicker-calendar-month">
					<div className="calendar-list-skeleton__month-title">
						<Skeleton width={96} height={14} />
					</div>
					<div className="react-calendar__month-view__days">
						{Array.from({ length: SKELETON_TILES_PER_MONTH }).map(
							(_unusedTile, tileIndex) => (
								<div className="date-picker-calendar-tile__tile" key={tileIndex}>
									<Skeleton width={20} height={12} radius="full" />
								</div>
							)
						)}
					</div>
				</div>
			</div>
		))}
	</div>
);

export default CalendarListSkeleton;
